const mobileToggleWrapper = document.querySelector(".mobile-toggle-wrapper");
const mobileToggleClose = document.querySelector(".mobile-toggle-close");

mobileToggleClose.addEventListener("click", function() {
    mobileToggleWrapper.classList.remove("active");
    mobileToggleWrapper.removeAttribute("open");
});


document.querySelectorAll('.parent-link').forEach(link => {
    link.addEventListener('click', () => {
        document.querySelectorAll('.parent-link').forEach(pl => {
            pl.style.color = 'transparent';
        });
    });
});


document.querySelectorAll('.parent-link-back--button').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelectorAll('.parent-link').forEach(pl => {
            pl.style.color = '#fff';
        });
    });
});